import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./component/modern-navigation";
import SmoothScroll from "smooth-scroll";
import AppIndex from "./AppIndex";
import { useEffect, useState } from "react";
import { Footer } from "./component/mainFooterSection";
// import { BlogHomepage, ProductsHomepage } from "./component/ProductsHomepage";
import { BlogPostDetail } from "./component/blogPostDetail";
import { Gallery } from "./component/galleryMainSection";
// import { ProductGridmainSQuotationDownloadModalection } from "./component/productGridmainSection";
// import { ProductDetail } from "./component/productDetail";
import { MaintenanceMode } from "./component/MaintenanceMode";
import { BookFreeSiteVisitSection } from "./component/BookFreeSiteVisitSection";
import { ProfessionalCollections } from "./component/professionalCollectionsSection";
import ConcreteMattPage from "./component/ConcreteMattPage";
import { ContactPage } from "./component/contactPage";
import LoadingAM from "./assets/Frame 5.gif";
import CartPage from "./component/CartPage";
import Measurement from "./component/measurement";
import MeasurementTable from "./component/measurementTable";
import Flipbook from "./component/FlipBook";
import { ProductGridmainSection } from "./component/productGridmainSection";
import PartnerPage from "./component/PartnerPage";
// import { Measurement } from "./component/measurement";
// import PDFGenerator from "./component/PDFGenerator";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    fetch("https://webadmin.naturx.co.in/api/get_extra_details")
      .then((res) => res.json())
      .then((data) => {
        if (data?.final === true || data?.final === "true") {
          setIsMaintenanceMode(true);
        } else {
          setIsMaintenanceMode(false);
        }
      })
      .catch((error) => {
        console.error("API fetch error:", error);
        // 👇 Force MaintenanceMode if API fails
        setIsMaintenanceMode(true);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="text-center py-24 mt-50 w-[100%] min-h-[80vh] flex justify-center items-center">
        <img src={LoadingAM} className="w-[70px] h-[70px]" alt="Loading" />
      </div>
    );

  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }
  return (
    <>
      {/* <MaintenanceMode /> */}
      <Router>
        <div className="">
          <Navigation />

          <Routes>
            <Route
              index
              element={
                <div className="App">
                  <AppIndex />
                </div>
              }
            />
            <Route
              path="/App"
              element={
                <div className="App">
                  <AppIndex />
                </div>
              }
            />
            <Route
              path="/Products/:id/:name"
              element={<ProfessionalCollections />}
            />
            <Route
              path="/Product/:id/:page/:main_cat_id/:CategoryId/:name"
              element={<ConcreteMattPage />}
            />
            <Route path="/gallery" element={<Gallery />} />
            <Route
              path="/collections/:id/:main_cat_id"
              element={<ProductGridmainSection />}
            />
            <Route
              path="/BookFreeSiteVisit"
              element={<BookFreeSiteVisitSection />}
            />
            {/* Partner */}
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/cart" element={<CartPage />} />
            {/* <Route path="/PDFGenerator" element={<PDFGenerator />} /> */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog/:id" element={<BlogPostDetail />} />
          </Routes>
          <Routes>
            <Route path="/measurement" element={<Measurement />} />
            <Route path="/Flipbook" element={<Flipbook />} />
            <Route path="/measurement/:id" element={<Measurement />} />
            <Route path="/measurementTabale" element={<MeasurementTable />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
